import React, { useState } from 'react';
import styled from 'styled-components';
import { tabletMediaQuery } from '../../Theming';

const Container = styled.div``;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${tabletMediaQuery} {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

const MainText = styled.span`
  font-family: Arial;
  font-size: 20px;
  line-heignt: 120%;
  margin-top: 15px;

  ${tabletMediaQuery} {
    font-size: 14px;
  }
`;

const HeaderText = styled.span`
  font-family: Arial;
  font-size: 30px;
  line-heignt: 130%;
  font-weight: bold;

  ${tabletMediaQuery} {
    font-size: 16px;
  }
`;

const FaqQuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  ${tabletMediaQuery} {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

const FaqItem = styled.div`
  width: 692px;
  height: 72px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-inline: 10px;

  &:first-child {
    border-top: 1px solid rgba(0, 0, 0, 0.5);
  }

  ${tabletMediaQuery} {
    width: 100%;
    height: 50px;
  }
`;

const FaqQuestion = styled.span`
  font-size: 20px;
  font-family: Arial;

  ${tabletMediaQuery} {
    font-size: 14px;
  }
`;

const FaqCircle = styled.div`
  height: 24px;
  width: 24px;
  font-size: 24px;
  border: 2px solid rgba(0, 0, 0);
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FaqLink = styled.span`
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  padding-top: 40px;
  font-size: 20px;
  text-decoration: underline;
  font-family: Arial;

  ${tabletMediaQuery} {
    font-size: 16px;
  }
`;

const FaqAnswerContainer = styled.div``;
const FaqAnswer = styled.span``;

interface Faq {
  question: string;
  answer: string;
}

interface FaqProps {
  headerText?: string;
  mainText?: string;
  faqs?: Faq[];
  linkText?: string;
}

const Faq: React.FC<FaqProps> = ({ headerText, mainText, faqs, linkText }) => {
  return (
    <Container>
      <TextContainer>
        <HeaderText>{headerText}</HeaderText>
        <MainText>{mainText}</MainText>
      </TextContainer>

      <FaqQuestionsContainer>
        {faqs?.map((faq, index) => {
          return (
            <FaqItem key={`faq-${index}`}>
              <FaqQuestion>{faq.question}</FaqQuestion>
              <FaqCircle>+</FaqCircle>
            </FaqItem>
          );
        })}
      </FaqQuestionsContainer>

      <FaqLink>{linkText}</FaqLink>
    </Container>
  );
};

export default Faq;
